export default {

  watch: {
    inputValue(newValue) {
      if (this.pristine && newValue !== null && !(typeof newValue === 'object' && newValue.length === 0)) {
        this.pristine = false;
      }
    },
    valid() {
      this.validationCallback();
    },
  },

  props: {
    validate: {
      type: Boolean,
      default: true,
    },
    errorMessage: {
      type: String,
      default: null,
    },
    errorIcon: {
      type: [String, Boolean],
      default: true,
    },
    validIcon: {
      type: [String, Boolean],
      default: true,
    },
    required: {
      type: Boolean,
      default: false,
    },   
  },

  data() {
    return {
      pristine: true,
    }
  },

  mounted() {
    this.validationCallback();
  },

  computed: {
    valid() {
      return this.regExp ? this.regExp.test(this.inputValue) : true;
    },
    showValidClass() {
      return this.validate && !this.pristine && this.valid;
    },
    showErrorClass() {
      return this.validate && !this.pristine && !this.valid;
    },
    showErrorMessage() {
      return this.showErrorClass && this.errorMessage;
    },
    showErrorIcon() {
      return this.validate && !this.pristine && !this.valid && this.errorIcon !== false;
    },
    showValidIcon() {
      return this.validate && !this.pristine && this.valid && this.validIcon !== false;
    },
    altValidIcon() {
      return typeof this.validIcon === 'string' ? this.validIcon : false;
    },
    altErrorIcon() {
      return typeof this.errorIcon === 'string' ? this.errorIcon : false;
    },
  },

  methods: {
    validationCallback() {
      this.$emit('validated', this.required ? this.inputValue !== null && this.valid : this.valid);
    }
  }
}